<template>
  <v-container id="app-qr-code-main-container" fluid class="pa-0">
    <qrcode-vue :background="background" :class="cssClass" :level="errorCorrectionLevel" :foreground="foreground" :margin="margin"
      :renderAs="renderAs" :size="size" :value="value" />
  </v-container>
</template>

<script>
// https://www.npmjs.com/package/qrcode.vue
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'AppQrCode',
  components: { QrcodeVue },
  props: {
    background: { default: '#ffffff' },
    cssClass: { default: '' },
    errorCorrectionLevel: { default: 'H' },
    foreground: { default: '#000000' },
    margin: { default: 0 },
    renderAs: { default: 'canvas' },
    size: { default: 100 },
    value: { default: '' }
  }
};
</script>
